import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { PRIMARY } from "../../theme/theme";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";

const Hero: React.FC = () => {
  return (
    <Box
      sx={{
        py: 8,
        backgroundColor: "background.paper",
        borderBottom: `1px solid rgba(0, 0, 0, 0.05)`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            maxWidth: "800px",
            mx: "auto",
          }}
        >
          <img
            src="/logo.svg"
            alt="Microlearning App Logo"
            style={{ height: "100px", marginBottom: "24px" }}
          />
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              mb: 2,
            }}
          >
            Learn Efficiently with Bite-Sized Lessons
          </Typography>
          <Typography
            variant="h5"
            color="text.secondary"
            paragraph
            sx={{ mb: 4, maxWidth: "700px" }}
          >
            Access a variety of learning materials in short, focused lessons
            that fit into your busy schedule.
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                backgroundColor: PRIMARY,
                "&:hover": {
                  backgroundColor: "#600018",
                },
              }}
              href="https://play.google.com/store/apps/details?id=com.blueberrybytes.microlearningapp"
              target="_blank"
              startIcon={<AndroidIcon />}
            >
              Google Play
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                borderColor: PRIMARY,
                color: PRIMARY,
                "&:hover": {
                  borderColor: "#600018",
                  backgroundColor: "rgba(128, 0, 32, 0.04)",
                },
              }}
              href="https://apps.apple.com/es/app/microlearning-daily/id6744894166"
              target="_blank"
              startIcon={<AppleIcon />}
            >
              App Store
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
